var React = require('react');

function CaretCircleRight (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm95.5 256.5l-123 123A12 12 0 0 1 208 379V133a12 12 0 0 1 20.5-8.5l123 123a12 12 0 0 1 0 17z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M351.5 264.5l-123 123A12 12 0 0 1 208 379V133a12 12 0 0 1 20.5-8.5l123 123a12 12 0 0 1 0 17z","className":"fa-primary","key":2})]);
}

CaretCircleRight.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = CaretCircleRight;

CaretCircleRight.default = CaretCircleRight;
